import React, { useCallback } from 'react';

import { useDispatch } from 'Modules/core/redux';
import { Button } from 'Modules/ui';
import { useTranslation } from 'Modules/core/i18n';

import { environmentActions } from '../../state/actions';


export const LogoutButton = ({ className, resetRoute }) => {
    const { t } = useTranslation('logoutButton');
    const dispatch = useDispatch();
    const logout = useCallback(
        () => dispatch(environmentActions.requestLogout(resetRoute)),
        [resetRoute, dispatch],
    );
    return (
        <Button className={className} variant='light' onClick={logout}>
            {t('text')}
        </Button>
    );
};
